import { render, staticRenderFns } from "./IdentityVerification.vue?vue&type=template&id=ab82c402&scoped=true"
import script from "./IdentityVerification.vue?vue&type=script&lang=js"
export * from "./IdentityVerification.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerification.vue?vue&type=style&index=0&id=ab82c402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab82c402",
  null
  
)

export default component.exports